import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/company_logo.svg")